import { lazy } from "react";

export const PageViewContact = lazy(() => import("./Contact"));
